import React from 'react';
import { Button, Grid, TableBody, TableCell, TableRow, Typography, withStyles } from '@material-ui/core';

import swal from '@sweetalert/with-react';

import SubTitle from '../components/Text/SubTitle';
import Table from '../components/Table/Table';
import { EVENT_IMG } from '../constatns';

const styles = (theme) => ({
  topSpacing: {
    paddingTop: theme.spacing(4),
  },
  body: {
    color: '#555',
    fontSize: '1.2em',
    lineHeight: 1.6,
  },
  content: {
    color: '#555',
  },
  emailAddress: {
    color: '#3b63ca',
  },

  styledTh: {
    '& th': {
      color: '#7d889a',
    },
    '& tr th:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  styledTd: {
    '& tr td:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  orderedList: {
    '& li': { fontWeight: 500, fontSize: '1.2em', lineHeight: 1.7 },
    '& dl': { fontWeight: 500, fontSize: '1.2em', lineHeight: 1.7 },
  },
});

const StyledTypo = withStyles((theme) => ({
  root: {
    color: '#647186',
    fontSize: '1.3em',
    fontWeight: 'bold',
  },
}))(Typography);

const PREPARE_TABLE_DATA = {
  Presentation: 'Presentation selected as E-Poster don’t have presentation time, and it will only be displayed during the conference.',
  Comment:
    'Please make sure to meet the submission deadline. Files submitted after the deadline may not be uploaded properly on the virtual platform, and be cancelled.',
  'Poster display': 'Your E-poster will be displayed on the website during the Conference. (November 12-14)',
  'File Name': 'PRS-0000_Presenter Name (Abstract No._Presenter Name)',
};

const TEMPLATE_TABLE_DATA = {
  Language: 'English',
  Format: (
    <div>
      MS-PowerPoint (MS Office 2010, 2013, 2016, 2019)
      <br />
      E-Poster file : PPT
      <br />
      <span style={{ color: '#f00' }}>** Please submit final file as a PPT file.</span>
    </div>
  ),
  'Screen Ratio': (
    <div>
      <p style={{ color: '#f00', fontWeight: 'bold', fontSize: '1.2em' }}>PowerPoint 4:3 size</p>
      <p>As for the aspect ratio of your presentation file (slides), a ratio of 4:3 is recommended.</p>
      <img src="/images/PRS2021/freepaper/presentation_01.png" style={{ width: '30%' }} alt="" />
      <img src="/images/PRS2021/freepaper/presentation_02.png" style={{ width: '80%' }} alt="" />
    </div>
  ),
  'Number of Slides': 'Maximum 6 Slides(including main template)',
  Font: (
    <div>
      Default font porovided by MS Office
      <br />
      (such as Arial, Calibri or Times New Roman)
    </div>
  ),
  'First Slide': (
    <div>
      The following must be included on the first slide of your file :<br />
      Abstract Title, Presenter’s Name and Co-author’s Names, Affiliation and Country.
    </div>
  ),
  Remarks: (
    <div>
      All pages must be within 6 pages.
      <br />
      Pictures, graphs and tables can be included in the E-Poster file.
      <br />
      Video <b>must not be included in E-Poster.</b>
    </div>
  ),
  Template: (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      disableElevation
      onClick={() => window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2021/templates/PRS2021_EPOSTER_PPT_Template.pptx')}
    >
      Template Download
    </Button>
  ),
};

const SUBMIT_TABLE_DATA = {
  'Deadline for Submission': <span style={{ color: '#f00' }}>August 13(Sat),2022</span>,
  'File Name': 'PRS-0000_Presenter Name (Abstract No._Presenter Name)',
  Submission: (
    <div>
      Please submit your file on the PRS KOREA 2022 website.
      <br />
      <b>Log-in → My Page → Abstract Submission → E-poster File Upload</b>
    </div>
  ),
};

class PresentationPoster extends React.Component {
  renderTable(mapObj) {
    return (
      <Table>
        <TableBody className={this.props.classes.styledTd}>
          {Object.entries(mapObj).map((data, idx) => (
            <TableRow key={`table-row-${idx}`}>
              <TableCell width="20%" align="center" style={{ fontWeight: 600 }}>
                {data[0]}
              </TableCell>
              <TableCell width="80%" style={{ padding: this.props.theme.spacing(0, 3) }}>
                {data[1]}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { classes, theme } = this.props;

    const spacing = (heightNum) => {
      return <div style={{ height: `${heightNum ? heightNum : 20}px` }} />;
    };

    return (
      <>
        <Grid item xs={8} style={{ paddingTop: theme.spacing(5) }}>
          <SubTitle>Guidelines for E-Poster Exhibition</SubTitle>
        </Grid>
        <Grid item xs={8}>
          <Typography className={classes.body}>
            {/* All the posters will be presented as E-posters, poster submitters do not need to bring a printed copy of their posters.
            <br />
            Posters will not be presented with voice, however, they can be viewed on a virtual platform in the E-Poster section.
            <br />
            Please make your E-poster file to meet the following criteria and upload the file on website ‘My Page’. */}
            Regardless of attendance type, all presenters must submit the following materials by &nbsp;
            <span style={{ color: 'red', fontWeight: 'bold' }}>October 17(Mon).</span>
          </Typography>
          {spacing(48)}

          {/* <Table>
            <TableHead className={classes.styledTh}>
              <TableRow>
                <TableCell>Category</TableCell>
                <TableCell>File Format</TableCell>
                <TableCell>Presentation & Q&A</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.styledTd}>
              <TableRow>
                <TableCell align="center">E-Poster</TableCell>
                <TableCell align="center">MS-PowerPoint</TableCell>
                <TableCell align="center">No Presentation, Q & A</TableCell>
              </TableRow>
            </TableBody>
          </Table> */}
          <Table>
            <TableBody className={this.props.classes.styledTh}>
              <TableRow>
                <TableCell
                  width="30%"
                  align="center"
                  style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}
                  rowSpan={3}
                >
                  E-Poster file
                  <br />
                  <span style={{ color: 'red', fontWeight: 'bold' }}>October 17(Mon)</span>
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  Poster file will be displayed on the digital signage during the conference day.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  Official Language: <span style={{ color: 'red', fontWeight: 'bold' }}>English</span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  E-Poster Slide Ratio: <span style={{ color: 'red', fontWeight: 'bold' }}>1080 x 1920 px </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  Poster display location
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  5F Lobby (Grand Intercontinental Seoul Parnas)
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  PPT Template File
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  * Template Download
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ textTransform: 'none', fontWeight: 'bold', marginLeft: 10 }}
                    onClick={() => {
                      window.open(
                        `https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/paper/PRS%2BKOREA%2B2022_E-Poster_PPT_Template.pptx`,
                        '_blank',
                      );
                    }}
                  >
                    Click
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  Submit
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  * Submit to
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ textTransform: 'none', fontWeight: 'bold', marginLeft: 10 }}
                    onClick={() => {
                      window.open(`https://www.dropbox.com/request/tdC0PrukzGkuzwsAotOu`, '_blank');
                    }}
                  >
                    Click
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        <Grid item xs={8} style={{ paddingTop: theme.spacing(5) }}>
          <SubTitle>Submission (by October 21(Fri), 2022)</SubTitle>
          <ul className={classes.orderedList}>
            {/* <br />
            <li>
              Submit to
              <Button
                color="primary"
                variant="contained"
                size="small"
                style={{ textTransform: 'none', fontWeight: 'bold', marginLeft: 10 }}
                onClick={() => {
                  window.open(`https://www.dropbox.com/request/tdC0PrukzGkuzwsAotOu`, '_blank');
                }}
              >
                Click
              </Button>
            </li>
            <br /> */}
            <li>File name: Abstract Number_Presenter’s Name, i.e. PRS2022_OK0001_Gildong Hong</li>
            <li>Write your first name, last name, e-mail address and click ‘Upload.’</li>
            <li>You will see the final screen when your presentation file is uploaded successfully.</li>
          </ul>
        </Grid>

        <Grid item xs={8} style={{ paddingTop: theme.spacing(5) }}>
          <SubTitle>E-Poster Preparation</SubTitle>
          <Grid container>
            <Grid item xs={3}>
              <img src={`${EVENT_IMG}/info/size.png`} alt="" style={{ width: '100%', maxWidth: 600 }} />
            </Grid>
            <Grid item xs={9}>
              <ul className={classes.orderedList} style={{ paddingLeft: 20 }}>
                <dl>
                  - Presentations selected as Poster Exhibition will NOT have allocated presentation time, and they will be displayed as
                  E-Posters during the conference.
                </dl>
                <dl>
                  - Please make sure to meet the submission deadline. Files submitted after the deadline may NOT be uploaded on the Digital
                  Signage.
                </dl>
                <dl>- Your Poster will be displayed via Digital Signage onsite.</dl>
                <dl>- When you make an E-Poster please follow the size according to the specification.</dl>
              </ul>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={8} style={{ paddingTop: theme.spacing(5) }}>
          <SubTitle>Presentation change and withdraw</SubTitle>

          <ul className={classes.orderedList}>
            <li>
              Presentation change and withdraw of the abstract should be notified in writing to the secretariat of PRS KOREA 2022 by E-mail.
              (<a href={'mailto:academic.kprs@innon.co.kr'}>academic.kprs@innon.co.kr</a>)
            </li>
          </ul>

          <Table>
            <TableBody className={this.props.classes.styledTh}>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  Date
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  October 21(Fri), 2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  Presentation change and withdraw request form Download(KOR)
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ textTransform: 'none', fontWeight: 'bold', marginLeft: 10 }}
                    onClick={() => {
                      window.open(
                        `https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/paper/%ED%95%99%EC%88%A0%EB%8C%80%ED%9A%8C+%EC%9E%90%EC%9C%A0%EC%97%B0%EC%A0%9C+%EB%B3%80%EA%B2%BD%2C+%EC%B2%A0%ED%9A%8C+%EC%82%AC%EC%9C%A0%EC%84%9C+%EC%96%91%EC%8B%9D.hwp`,
                        '_blank',
                      );
                    }}
                  >
                    Click
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="30%" align="center" style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold', fontSize: '1.2em' }}>
                  Presentation change and withdraw request form Download(ENG)
                </TableCell>
                <TableCell width="70%" align="left" style={{ fontSize: '1.2em' }}>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ textTransform: 'none', fontWeight: 'bold', marginLeft: 10 }}
                    onClick={() => {
                      window.open(
                        `https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/Presentation+change+and+withdraw+request+form+Download(ENG).docx`,
                        '_blank',
                      );
                    }}
                  >
                    Click
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>

        {/* <Grid item xs={8} className={classes.topSpacing}>
          <StyledTypo>How to prepare your E-Poster</StyledTypo>
          {spacing(10)}
          {this.renderTable(PREPARE_TABLE_DATA)}
        </Grid>
        <Grid item xs={8} className={classes.topSpacing}>
          <StyledTypo>Template</StyledTypo>
          {spacing(10)}
          {this.renderTable(TEMPLATE_TABLE_DATA)}
        </Grid>
        <Grid item xs={8} className={classes.topSpacing}>
          <StyledTypo>How to submit your file</StyledTypo>
          {spacing(10)}
          {this.renderTable(SUBMIT_TABLE_DATA)}
        </Grid>
        <Grid item xs={8} className={classes.topSpacing}>
          <div style={{ backgroundColor: '#eee', padding: this.props.theme.spacing(1, 2) }}>
            <Typography className={classes.body} style={{ fontWeight: 'bold' }}>
              For inquiries: PRS KOREA 2022 Secretariat
            </Typography>
            <p className={classes.content}>
              If you have any difficulties with submitting your file, please contact the PRS KOREA 2022 Secretariat.
              <br />
              E-mail: <a href={'mailto:secretariat.kprs@innon.co.kr'}>secretariat.kprs@innon.co.kr</a>
              <br />
              T. +82-2-6411-7380
            </p>
          </div>
        </Grid> */}
        {/* <Grid item xs={8} className={classes.topSpacing} style={{ textAlign: 'center' }}>
          <Button variant="contained" color="primary" size="large" disableElevation onClick={() => swal('준비중입니다.')}>
            Upload Site
          </Button>
        </Grid> */}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PresentationPoster);
